import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { BudBotLanguageModelResponse } from '../../../budbot/bud-bot-language-model-response';

export class WebSocketBudBotResponse extends WebSocketReceiveMessage {
  override payload: BudBotLanguageModelResponse;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize.instanceOf(BudBotLanguageModelResponse, this.payload);
  }
}
